export default __webpack_public_path__ + "static/media/edit-star-gradient.194325bb.svg";